// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../views/modules/testimonial-carousel/assets/scss/testimonial-carousel.scss
// module id = 133
// module chunks = 3